// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-Attachment__Attachment--TsEdb {\n    margin: 1rem 0;\n}\n", "",{"version":3,"sources":["webpack://./src/frontend/components/Attachment.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB","sourcesContent":[".Attachment {\n    margin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Attachment": "components-Attachment__Attachment--TsEdb"
};
export default ___CSS_LOADER_EXPORT___;
